import React, { useState, useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Hero from '../components/Hero/Hero';
import Services from '../components/Services/Services';
import Advantages from '../components/Advantages/Advantages';
import About from '../components/About/About';
import CarCarousel from '../components/CarCarousel/CarCarousel';
import VideoGrid from '../components/VideoGrid/VideoGrid';
import PriceList from '../components/PriceList/PriceList';
import PartsCatalog from '../components/PartsCatalog/PartsCatalog';
import Gallery from '../components/Gallery/Gallery';
import BookingForm from '../components/BookingForm/BookingForm';
import Contacts from '../components/Contacts/Contacts';
import { fallbackServices } from '../data/fallbackData';

/** Услуга «запчасти и ремонт ходовой» — под ней раскрывается каталог с ценами на сэлбэг. */
const CHASSIS_SERVICE_SLUG = 'yavakh-angiin-zasvar';

const HomePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeServiceSlug, setActiveServiceSlug] = useState(fallbackServices[0].slug);
  const [partsCatalogOpen, setPartsCatalogOpen] = useState(false);

  const applyServiceSelection = useCallback((slug) => {
    setActiveServiceSlug(slug);
    setPartsCatalogOpen(slug === CHASSIS_SERVICE_SLUG);
  }, []);

  const handleServiceCardClick = useCallback(
    (slug) => {
      applyServiceSelection(slug);
      document.getElementById('prices')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    [applyServiceSelection]
  );

  useEffect(() => {
    const slug = location.state?.priceSlug;
    if (!slug || typeof slug !== 'string') return;
    applyServiceSelection(slug);
    requestAnimationFrame(() => {
      document.getElementById('prices')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    navigate('/', { replace: true, state: {} });
  }, [location.state, applyServiceSelection, navigate]);

  return (
    <main>
      <Hero />
      <Services onServiceNavigate={handleServiceCardClick} />
      <Advantages />
      <About />
      <CarCarousel />
      <VideoGrid />
      <PriceList
        activeServiceSlug={activeServiceSlug}
        onSelectSlug={applyServiceSelection}
      />
      <PartsCatalog isOpen={partsCatalogOpen} onOpenChange={setPartsCatalogOpen} />
      <Gallery />
      <BookingForm />
      <Contacts />
    </main>
  );
};

export default HomePage;
